import { render, staticRenderFns } from "./OaPageHeader.vue?vue&type=template&id=4726c0bc"
import script from "./OaPageHeader.vue?vue&type=script&lang=js"
export * from "./OaPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports